"use strict";exports.buttonSizes=["xs","sm","md","lg"],exports.buttonVariants=["primary","primaryDestructive","secondary","secondaryDestructive","secondarySubtle","secondarySubtleDestructive","tertiary","tertiaryDestructive","ghost","ghostNeutral","ghostDestructive"];
//# sourceMappingURL=button.types-f42b599b.js.map
